import { render, staticRenderFns } from "./ARMHelpList.vue?vue&type=template&id=b6d49946&"
import script from "./ARMHelpList.vue?vue&type=script&lang=js&"
export * from "./ARMHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports